<template>
    <v-dialog
        v-model="swapLogsDialogShown"
        scrollable
        :fullscreen="!$isDesktop()"
        max-width="80vw">
        <v-card>
        <v-card-title class="mb-5 mt-7" style="font-size:1.3rem;">
            Swap Logs
        </v-card-title>
            <v-card-text class="mt-3">
                <v-form ref="form" v-model="valid" lazy-validation>
                    <v-container :style="{maxWidth: !$isDesktop() ? '100vw' : null}">
                        <!-- >>> The Data Table -->
                        <v-data-table
                            v-model="dataTable_selected"
                            :headers="headers"
                            :items="swapLogs"
                            :hide-default-footer="true"
                            :single-select="false"
                            sort-by="id"
                            show-select
                            :disable-pagination="true"
                            :items-per-page="-1"
                            class="elevation-1 mb-0 mt-0 "
                            color="primary">
                            <template v-slot:[`item.created`]="{ item }">
                                <span style="display:flex;align-items:center;">
                                    <p style="margin:0;">{{ $dayjsLocalToUTC(item.created, 'DD.MM.YYYY HH:mm') }}</p>
                                </span>
                            </template>
                            <template v-slot:[`item.destinationDate`]="{ item }">
                                <span style="display:flex;align-items:center;">
                                    <p style="margin:0;">{{ $dayjsLocalToUTC(item.destinationDate, 'DD.MM.YYYY HH:mm') }}</p>
                                </span>
                            </template>
                            <template v-slot:[`item.swappedTo`]>
                                <span style="display:flex;align-items:center;">
                                    <p style="margin:0;"><v-icon>mdi-arrow-right</v-icon></p>
                                </span>
                            </template>
                            <template v-slot:[`item.originDate`]="{ item }">
                                <span style="margin-left: 15px;display:flex;align-items:center;">
                                    <p style="margin:0;">{{ $dayjsLocalToUTC(item.originDate, 'DD.MM.YYYY HH:mm') }}</p>
                                </span>
                            </template>
                            <template v-slot:[`item.result.warnings`]="{ item }">
                                <span style="margin-left: 15px;display:flex;align-items:center;">
                                    <div style="margin:0;">
                                        <p v-for="(warning, i) in item.result.warnings" :key="i">
                                            {{ warning }}
                                        </p>
                                    </div>
                                </span>
                            </template>
                            <!-- >>> Action:Column -->
                            <!-- solved in vue3: https://stackoverflow.com/questions/61344980/v-slot-directive-doesnt-support-any-modifier -->
                            <template v-slot:[`item.actions`]="{ item }">
                                <span>
                                    <v-icon small class="mr-2" @click="onClick_deleteSwapLog(item)">
                                        mdi-delete
                                    </v-icon>
                                </span>
                            </template>
                            <!-- <<< Action:Column -->
                        </v-data-table>
                    </v-container>
                </v-form>
            </v-card-text>
            <!-- >>> Action Buttons -->
            <v-card-actions style="margin-top: 20px; padding-bottom:10px">
                <v-spacer />
                <v-btn style="width:120px" depressed elevation="1" outlined color="#ab3b7a" @click="swapLogsDialogShown = false">
                    Close
                </v-btn>
                <v-btn style="width:190px" depressed elevation="1" color="primary" @click="onClick_deleteSelectedSwapLogs()">
                    Delete Selected Swap Logs
                </v-btn>
            </v-card-actions>
            <!-- <<< Action Buttons -->
        </v-card>
    </v-dialog>
</template>

<script>
    import Vue from 'vue';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        name: 'SwapLogs',

        /* >>> *************************************************************** / /* Components */
        components: {}, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Props */
        props: {

            value: [Boolean] // 'showSheet' itself

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function () {

            return {
                // >>> ------------------------------------ 'General'
                // >>> ------------------------------------ 'Form Validation Rules'
                valid: false,
                // >>> ------------------------------------ 'Data Table'
                swapLogs: [],
                dataTable_selected: [],
                // >>> Data Table Header ------------------
				headers: [
                    { text: '', value: 'data-table-select', class: 'sticky-header grey lighten-3' },
                    { text: 'Created', value: 'created', class: 'sticky-header grey lighten-3' },
					{ text: 'Date', value: 'destinationDate', class: 'sticky-header grey lighten-3' },
					{ text: 'Flight No.', value: 'destinationFlightNo', class: 'sticky-header grey lighten-3' },
					{ text: 'Dep. Airp.', value: 'destinationAptFrom', class: 'sticky-header grey lighten-3' },
					{ text: 'Arr. Airp.', value: 'destinationAptTo', class: 'sticky-header grey lighten-3' },

                    { text: '', value: 'swappedTo', class: 'sticky-header grey lighten-3' },

                    { text: 'Date', value: 'originDate', class: 'sticky-header grey lighten-3' },
                    { text: 'Flight No.', value: 'originFlightNo', class: 'sticky-header grey lighten-3' },
					{ text: 'Dep. Airp.', value: 'originAptFrom', class: 'sticky-header grey lighten-3' },
					{ text: 'Arr. Airp.', value: 'originAptTo', class: 'sticky-header grey lighten-3' },

					{ text: 'Warning', value: 'result.warnings', sortable: false, class: 'sticky-header grey lighten-3' },
					{ text: 'Actions', value: 'actions', sortable: false, class: 'sticky-header grey lighten-3' },
					{ text: '', value: 'data-table-expand', class: 'sticky-header grey lighten-3' }
					// currently not needed - maybe later
					// { text: '', value: 'data-table-expand', class: 'sticky-header grey lighten-3' },
				]
				// >>> ------------------------------------
            };

        }, // eo funtion data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_flights_swapLogs'
            ]),


            /*******************************************************************
            * swapLogsDialogShown{}
            *
            * Desc:
            * Note:
            *
            */
            swapLogsDialogShown: {

                get() {
                    const me = this;


                    me.$toc('>>> views/shared/components/core/components/SwapLogs.vuee >>> computed/swapLogsDialogShown/get');

                    return me.value;

                }, // eo function swapLogsDialogShown get()


                set(value) {

                    const me = this;


                    me.$toc('>>> views/shared/components/core/components/SwapLogs.vue >>> computed/swapLogsDialogShown/set');

                    if (typeof value === 'boolean') {
                        this.$emit('input', value);
                    }


                } // eo function swapLogsDialogShown set()

            } // eo function swapLogsDialogShown()

        }, // eo function created{}
        /* <<< ****************************************************************/

        /* >>> *************************************************************** / /* watch */
        watch: {

            get_flights_swapLogs(val) {

                const me = this;

                me.$toc('>>> views/shared/components/core/components/SwapLogs.vue >>> watch/get_flights_swapLogs');
                me.swapLogs = val.map(v => {
                    v.result.warnings = v.result.warnings.split('\n');
                    return v;
                });

            }
        }, // eo computed{}
        /* <<< ****************************************************************/


        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        created: function() {

            const me = this;


            me.$toc('>>> views/shared/components/core/components/SwapLogs.vue >>> created');
            me.actn_call_swapLogsDownload();

        }, // eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* methods */
        methods: {

            /*******************************************************************
            * mapActions{}
            *
            * Desc:
            * Note:
            *
            */
            ...mapActions([
                'actn_call_swapLogsDownload',
                'actn_call_deleteSwapLog'
            ]), // eof mapActions

            /*******************************************************************
            * onClick_deleteSwapLog{}
            *
            * Desc:
            * Note:
            *
            */
            onClick_deleteSwapLog: function(item) {

                const me = this;


                me.$toc('>>> views/shared/components/core/components/SwapLogs.vue >>> onClick_deleteSwapLog');
                me.actn_call_deleteSwapLog({
                    payload: { idLogs: [item.id] }
                });

            }, // eof onClick_deleteSwapLog{}

            /*******************************************************************
            * onClick_deleteSelectedSwapLogs{}
            *
            * Desc:
            * Note:
            *
            */
            onClick_deleteSelectedSwapLogs: function() {

                const me = this;


                me.$toc('>>> views/shared/components/core/components/SwapLogs.vue >>> onClick_deleteSelectedSwapLogs');
                me.actn_call_deleteSwapLog({
                    payload: {
                        idLogs: me.dataTable_selected.map(d => {
                            return d.id;
                        })
                    }
                });

            } // eof onClick_deleteSelectedSwapLogs{}

        }
    };
</script>

<style scoped>
</style>
